'use strict';

import React from 'react';
import Footer from './FooterComponent';
import Navigator from './NavigatorComponent';
import AlbumStore from 'stores/AlbumStore';
import AlbumActions from 'actions/AlbumActions';
import Loading from './LoadingComponent';
import AlbumsList from './AlbumsListComponent';
import API from 'sources/API';
import 'styles/Albums.scss';

class AlbumsComponent extends React.Component {
  constructor(props) {
    super(props);
    let albumStore = AlbumStore.getState();
    this.state = {
      albums: albumStore.albums,
      loading: true,
      hasMore: true,
      showNavigator: false
    };
    this.onAlbumsChange = this.onAlbumsChange.bind(this);
    this.onAlbumScroll = this.onAlbumScroll.bind(this);
    this.loadMore = this.loadMore.bind(this)
  }
  componentWillMount() {
    //update album list page
    let { page } = this.props.params;
    if(page){
      AlbumActions.updateFirst(page);
    }
  }
  componentDidMount() {
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
            window.wx.config(json);
        }
      })
    }
    let albumStore = AlbumStore.getState();
    window.scrollTo(0, albumStore.offset);

    if(this.state.albums.length === 0) {
      AlbumActions.cleanAlbumList();
      AlbumActions.fetchAlbumList();
    }

    AlbumStore.listen(this.onAlbumsChange);
    window.addEventListener('scroll', this.onAlbumScroll);

    window.wx.ready(()=>{
      window.wx.onMenuShareTimeline({
        title: "合辑-小地球旅行", // 分享标题
        link: location.href, // 分享链接
        imgUrl: 'https://img.xiaodiqiu.cn/share.png', // 分享图标
      });
      window.wx.onMenuShareAppMessage({
        title: "合辑-小地球旅行", // 分享标题
        desc: "加入小地球旅行，发现有趣的地方", // 分享描述
        link: location.href, // 分享链接
        imgUrl: 'https://img.xiaodiqiu.cn/share.png', // 分享图标
        type: 'link' // 分享类型,music、video或link，不填默认为link
      });
    });

    window.changeMetaForSEO(false);
    window._hmt.push(['_trackPageview', this.props.location.pathname]); 
  }
  componentWillUnmount() {
    AlbumActions.updateOffset($(document).scrollTop());
    AlbumStore.unlisten(this.onAlbumsChange);
    window.removeEventListener('scroll', this.onAlbumScroll);
  }
  onAlbumsChange(state) {
    this.setState({
      albums: state.albums,
      loading: state.loading,
      hasMore: state.hasMore
    });
  }
  onAlbumScroll(event) {
    if(this.state.fetchTimeout) {
      clearTimeout(this.state.fetchTimeout);
    }
    let scrollTop = $(document).scrollTop();
    let clientHeight = event.srcElement.body.clientHeight;
    let scrollHeight = event.srcElement.body.scrollHeight;
    if(scrollTop + clientHeight === scrollHeight) {
      AlbumActions.setLoading(true);
      this.setState({fetchTimeout: setTimeout(AlbumActions.fetchAlbumList, 1000)});
    }
    if(scrollTop > 500){
      this.setState({showNavigator:true});
    }else{
      this.setState({showNavigator:false});
    }
  }
  loadMore() {
    AlbumActions.setLoading(true);
    AlbumActions.fetchAlbumList()
  }
  render() {
    let navigator;
    if(this.state.showNavigator){
      navigator = <Navigator action='top' />;
    }
    return (
      <div className="albums-component">
        <AlbumsList albums={this.state.albums} loading={this.state.loading} />
        <Loading loading={this.state.loading} hasMore={this.state.hasMore} loadMore={this.loadMore}/>
        {navigator}
        <Footer />
      </div>
    );
  }
}

AlbumsComponent.displayName = 'AlbumsComponent';
export default AlbumsComponent;



// WEBPACK FOOTER //
// ./src/components/AlbumsComponent.js